import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import reqwest from 'reqwest';
import swal from '@sweetalert/with-react';
import {
  faArrowLeft,
  faSave,
  faTimes,
} from '@fortawesome/pro-regular-svg-icons';
import settings from '../../../../../../settings';
import DataContainer from '../../../../../logic/dataContainer';
import Loader from '../../../../../components/Loader';
import Form from '../../../../../components/Form';
import ContentBox from '../../../../../components/FormArea/ContentBox';
import Button from '../../../../../components/Button';
import Input from '../../../../../components/Inputs/Input';
import Dropdown from '../../../../../components/Inputs/Dropdown';
import getConstants from '../../../../../logic/constants';
import HeaderbarButton from '../../../../../components/HeaderbarButton';
import moment from 'moment';
import { NavLink } from 'react-router-dom/cjs/react-router-dom.min';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class AppointmentNewEntry extends Component {
  constructor(props) {
    super(props);
    this.clientGuid = props.match.params.clientGuid;
    this.parentRoute = this.props.match.url.replace(new RegExp('/new'), '');

    this.state = {
      loading: false,
      PlaceOfConsultation: [],
      CarePsych: [],
      FormOfConsultations: [],
      TypeOfConsultations: [],
    };

    this.dataContainer = new DataContainer();
    this.dataContainer.add('Appointment', {
      Typ: 'Appointment',
      ClientGuid: this.clientGuid,
      DateOfAppointment: '',
      TimeOfAppointment: '',
      PlaceOfConsultation: '',
      CarePsych: '',
      FormOfConsultation: '',
      TypeOfConsultation: '',
    });
    this.initConstants();
  }

  getFormOfConsultationOptions() {
    return [
      { value: 'personal', label: 'Persönlich' },
      { value: 'telephon', label: 'Telefonisch' },
      { value: 'video', label: 'Video' },
    ];
  }

  async initConstants() {
    this.setState({
      PlaceOfConsultation: await getConstants('PlaceOfConsultation'),
      TypeOfConsultations: await getConstants('TypeOfConsultation'),
      CarePsych: await getConstants('CarePsych'),
      FormOfConsultations: this.getFormOfConsultationOptions(),
    });
  }

  save = async () => {
    const isValid = await this.form.validate();
    if (!isValid) {
      swal({
        title: 'Fehler bei Ihren Eingaben',
        icon: 'error',
        text: 'Bitte überprüfen Sie Ihre Eingaben und versuchen Sie es erneut.',
      });
      return;
    }

    const oneDataContainer = JSON.stringify({
      ParamName: 'Appointment',
      Params: this.dataContainer.get('Appointment'),
    });

    reqwest({
      method: 'POST',
      url: settings.clientmanagement.dataContainer.save,
      data: {
        container: oneDataContainer,
        action: 'Neuer Beratungstermin angelegt',
      },
    })
      .then((_) => {
        swal({
          title: 'Gespeichert!',
          text: 'Erfolgreich gespeichert.',
          icon: 'success',
        });
        this.props.history.goBack();
      })
      .catch(() => {
        swal({
          title: 'Speichern nicht möglich!',
          text: 'Es ist ein Fehler beim speichern aufgetreten',
          icon: '',
        });
      });
  };

  render() {
    if (this.state.loading) {
      return <Loader />;
    }

    return (
      <>
        <div className="Headerbar sticky">
          <div className="Headerbar-breadcrumbs">
            <Link to="/clientmanagement">Klientenverwaltung</Link> -{' '}
            <Link
              onClick={() => {
                this.props.history.push(
                  `/clientmanagement/detail/${this.clientGuid}`,
                );
              }}
            >
              Klient
            </Link>
            {' - '}
            <Link to={this.parentRoute}>Terminverwaltung</Link> -{' '}
            <b>Neuer Beratungstermin</b>
          </div>
          <div className="Headerbar-buttons">
            <HeaderbarButton
              icon={faTimes}
              onClick={() => {
                this.props.history.goBack();
              }}
            >
              Abbrechen
            </HeaderbarButton>
          </div>
        </div>
        <div className="Split-Panes-Menu">
          <div className="Split-Pane-Menu">
            <div className="Split-Pane-Menu-Nav">
              <NavLink className="FormArea-Body-Tab" to={this.parentRoute}>
                <FontAwesomeIcon icon={faArrowLeft} /> Zurück
              </NavLink>
            </div>
          </div>
          <div className="Split-Pane-Main">
            <div className="Page-Content">
              <div className="Buttonbar">
                <Button icon={faSave} onClick={this.save}>
                  Speichern
                </Button>
              </div>
              <Form
                ref={(node) => {
                  return (this.form = node);
                }}
              >
                <ContentBox title="Beratungstermin">
                  <Input
                    type="date"
                    validator={[
                      {
                        required: true,
                        error: 'Bitte Datum eingeben',
                      },
                      {
                        date: true,
                        error: 'Bitte Datum im Format DD.MM.YYYY eingeben',
                      },
                    ]}
                    onChange={(value) => {
                      this.dataContainer.set(
                        'Appointment',
                        'DateOfAppointment',
                      )(moment(value)?.format('YYYY-MM-DD'));
                    }}
                    defaultValue={moment(
                      this.dataContainer.get(
                        'Appointment',
                        'DateOfAppointment',
                      ),
                    )?.format('YYYY-MM-DD')}
                    label="Datum der Beratung"
                    name="DateOfAppointment"
                  />
                  <Input
                    type="time"
                    validator={[]}
                    onChange={(value) => {
                      this.dataContainer.set(
                        'Appointment',
                        'TimeOfAppointment',
                      )(value);
                    }}
                    defaultValue={this.dataContainer.get(
                      'Appointment',
                      'TimeOfAppointment',
                    )}
                    label="Uhrzeit"
                    name="TimeOfAppointment"
                  />

                  <Dropdown
                    label="Beratungsort:"
                    getSelected={(value) => {
                      this.dataContainer.set(
                        'Appointment',
                        'PlaceOfConsultation',
                      )(value);
                    }}
                    defaultValue={this.dataContainer.get(
                      'Appointment',
                      'PlaceOfConsultation',
                    )}
                    options={this.state.PlaceOfConsultation}
                    validator={[]}
                    name="PlaceOfConsultation"
                  />
                  <Dropdown
                    label="CARE-Psych.:"
                    getSelected={(value) => {
                      this.dataContainer.set('Appointment', 'CarePsych')(value);
                    }}
                    defaultValue={this.dataContainer.get(
                      'Appointment',
                      'CarePsych',
                    )}
                    options={this.state.CarePsych}
                    validator={[]}
                    name="CarePsych"
                  />
                  <Dropdown
                    label="Form der Beratung:"
                    getSelected={(value) => {
                      this.dataContainer.set(
                        'Appointment',
                        'FormOfConsultation',
                      )(value);
                    }}
                    defaultValue={this.dataContainer.get(
                      'Appointment',
                      'FormOfConsultation',
                    )}
                    options={this.state.FormOfConsultations}
                    validator={[]}
                    name="FormOfConsultation"
                  />
                  <Dropdown
                    label="Art der Beratung:"
                    getSelected={(value) => {
                      this.dataContainer.set(
                        'Appointment',
                        'TypeOfConsultation',
                      )(value);
                    }}
                    defaultValue={this.dataContainer.get(
                      'Appointment',
                      'TypeOfConsultation',
                    )}
                    options={this.state.TypeOfConsultations}
                    validator={[]}
                    name="TypeOfConsultation"
                  />
                </ContentBox>
              </Form>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(AppointmentNewEntry);
